import RatingsStatsBaseball from "./RatingsStats.baseball.tsx";
import RatingsStatsBasketball from "./RatingsStats.basketball.tsx";
import RatingsStatsFootball from "./RatingsStats.football.tsx";
import RatingsStatsHockey from "./RatingsStats.hockey.tsx";
import { useLocal } from "../../util/local.ts";
import { bySport } from "../../../common/sportFunctions.ts";

export const RatingsStats = (props: {
	ratings: any;
	stats: unknown;
	type?: "career" | "current" | "draft" | number;
}) => {
	const { challengeNoRatings } = useLocal(["challengeNoRatings"]);

	return bySport({
		baseball: RatingsStatsBaseball({
			...props,
			challengeNoRatings,
		}),
		basketball: RatingsStatsBasketball({
			...props,
			challengeNoRatings,
		}),
		football: RatingsStatsFootball({
			...props,
			challengeNoRatings,
		}),
		hockey: RatingsStatsHockey({
			...props,
			challengeNoRatings,
		}),
	});
};
